const CONTENT = {
  care: {
    title: "Wig Care Guide",
    subtitle: "How to keep your Maison Luxe wig salon-fresh.",
    sections: [
      ["Wash Routine", "Detangle gently from tip to root. Use a sulphate-free shampoo, lather lightly with cool water. Avoid rubbing the lace. Apply a deep conditioner from mid-shaft to ends and leave for 10 minutes. Rinse thoroughly with cool water."],
      ["Drying", "Pat (don't rub) excess water with a microfibre towel. Air-dry on a wig stand or use a hooded dryer on a cool setting. Avoid blow-drying directly on the lace."],
      ["Heat Styling", "Human-hair wigs tolerate heat up to 180°C. Always use a heat protectant. Synthetic blends should be styled with heat-resistant tools at low settings only."],
      ["Storage", "Store on a wig stand or in the original tissue packaging. Avoid direct sunlight, humidity and friction (which causes tangling)."],
      ["Refresh Between Wears", "Spritz a leave-in conditioner from mid-shaft to ends every 2–3 wears. Detangle nightly with a wide-tooth comb."],
    ],
  },
  lace: {
    title: "Lace Guide",
    subtitle: "Understanding HD, transparent, 13x4, 4x4 & more.",
    sections: [
      ["HD Lace", "Our most advanced lace base. Ultra-thin, undetectable, melts seamlessly into the skin. Recommended for the most natural finish, photos and special occasions."],
      ["Transparent Lace", "A slightly thicker lace that disappears against medium to light skin tones. More durable than HD lace."],
      ["Frontal Lace (13x4 / 13x6)", "13 inches across the forehead and 4–6 inches deep. Allows you to style any parting, including pulled-back updos and ponytails along the front."],
      ["Closure (4x4 / 5x5 / 6x6)", "A smaller lace panel for centre or side parts. Faster to install and ideal for beginners or low-maintenance styles."],
      ["Glueless / Wear-&-Go", "Pre-cut lace, elastic band and adjustable straps. No glue or wig caps required. Slip on, adjust, step out."],
    ],
  },
  beginner: {
    title: "Beginner Wig Guide",
    subtitle: "Your first wig, from unboxing to installed in 5 minutes.",
    sections: [
      ["Pick the Right Wig", "Beginners should start with a glueless, pre-plucked, pre-styled unit. Look for our 'Beginner Friendly' or 'Glueless Ready' badges."],
      ["Step 1: Prep Your Hair", "Braid your natural hair flat against the scalp or use a wig cap. Lay your baby hairs with a soft brush."],
      ["Step 2: Slip On", "Put the wig on from front to back. Position the front of the lace just above your natural hairline."],
      ["Step 3: Secure", "Adjust the elastic band behind your ears. Tighten the inner straps until snug (you should be able to fit one finger underneath)."],
      ["Step 4: Style", "Part the hair as desired. Use a light styling gel for your baby hairs. Spritz a leave-in conditioner for sheen. You're ready."],
    ],
  },
};

export default function GuidePage({ kind }) {
  const data = CONTENT[kind];
  if (!data) return null;
  return (
    <div data-testid={`guide-${kind}-page`} className="max-w-3xl mx-auto px-6 py-20">
      <p className="small-label">Guide</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">{data.title}</h1>
      <p className="text-stone mt-3">{data.subtitle}</p>
      <div className="mt-12 space-y-10">
        {data.sections.map(([t, b], i) => (
          <section key={i}>
            <p className="font-serif text-xl">{t}</p>
            <p className="text-stone mt-2 leading-relaxed">{b}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
